import type { ReactNode } from "react";
import { cn } from "~/lib/utils";
import { HeadingTitleStyle } from "../_config";
import { usePlan } from "../plan.context";

interface HeadingProps {
  pre: string;
  name: string;
  children: Readonly<ReactNode>;
}

export default function Heading({ pre, name, children }: HeadingProps) {
  const { color } = usePlan();
  return (
    <div>
      <h2 className="mb-4 text-4xl font-extrabold text-white">
        {(pre ?? "") + " "}
        <span className={cn("", HeadingTitleStyle[color])}>
          {name}
        </span>
      </h2>
      <p className="text-lg text-gray-400">{children}</p>
    </div>
  );
}
